<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col>
        <v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="content"
          label="Value"
          hide-details
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
const randomize = require("randomatic");
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => false,
    },
  },
  name: "third-party-setting-edit-dialog",
  components: { BasicDialog },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "",
      content: this.value ? this.value.content : "",
    };
  },

  computed: {
    isValid() {
      return this.name != "";
    },
    editorTitle() {
      return this.value
        ? "Edit Third Party Setting"
        : "Create Third Party Setting";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.name = newVal.name;
        this.content = newVal.content;
      } else {
        this.name = "";
        this.content = "";
      }
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value ? this.value.id : randomize("Aa0", 10),
        name: this.name,
        content: this.content,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/plugins/third-party-setups/ThirdPartySettingEditDialog.vue